// Generated by purs version 0.15.15
import * as Color from "../Color/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Filterable from "../Data.Filterable/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Interpolate from "../Data.Interpolate/index.js";
import * as Data_List_Lazy from "../Data.List.Lazy/index.js";
import * as Data_List_Lazy_Types from "../Data.List.Lazy.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Fusion_Data_Duration from "../Fusion.Data.Duration/index.js";
import * as Fusion_Data_Speed from "../Fusion.Data.Speed/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
var maximum = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Speed.ordSpeed)(Data_Foldable.foldableArray);
var greaterThanOrEq = /* #__PURE__ */ Data_Ord.greaterThanOrEq(Fusion_Data_Speed.ordSpeed);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(Fusion_Data_Duration.monoidDuration);
var maximum1 = /* #__PURE__ */ Data_Foldable.maximum(Fusion_Data_Duration.ordDuration)(Data_Foldable.foldableArray);
var convertDuration = /* #__PURE__ */ Data_Time_Duration.convertDuration(Fusion_Data_Duration.durationDuration)(Data_Time_Duration.durationSeconds);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var i = /* #__PURE__ */ Data_Interpolate.i(/* #__PURE__ */ Data_Interpolate.interpStringFunction(/* #__PURE__ */ Data_Interpolate.interpStringFunction(/* #__PURE__ */ Data_Interpolate.interpStringFunction(Data_Interpolate.interpString))));
var filterMap = /* #__PURE__ */ Data_Filterable.filterMap(Data_Filterable.filterableArray);
var mod = /* #__PURE__ */ Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt);
var withAttrs = function (dictSemigroup) {
    var append1 = Data_Semigroup.append(dictSemigroup);
    return function (f) {
        return function (x) {
            return function (y) {
                return f(append1(y)(x));
            };
        };
    };
};
var speedBoundaries = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray)(/* #__PURE__ */ Data_Array.fromFoldable(Data_List_Lazy_Types.foldableList)(/* #__PURE__ */ Data_List_Lazy.take(100)(/* #__PURE__ */ Data_List_Lazy.iterate(function (v) {
    return v * 2.0;
})(1.0e-3))))(function (s) {
    return Fusion_Data_Speed.fromBps(s * 1.0e9);
});
var overAlpha = function (f) {
    return function (color) {
        var v = Color["toRGBA$prime"](color);
        return Color["rgba$prime"](v.r)(v.g)(v.b)(f(v.a));
    };
};
var getVisibleSpeedMax = function (speeds) {
    var maxSpeed = Data_Maybe.fromMaybe(Fusion_Data_Speed.fromBps(1.0e9))(maximum(speeds));
    return Fusion_Data_Speed.scale(1.1)(Data_Maybe.fromMaybe(Fusion_Data_Speed.fromBps(1.0e9))(Data_Array.find(function (speed) {
        return greaterThanOrEq(speed)(maxSpeed);
    })(speedBoundaries)));
};
var getVisiblePingMax = function (durs) {
    var maxDur = Data_Maybe.fromMaybe(mempty)(maximum1(durs));
    return maxDur;
};
var formatDigitalClock = function (v) {
    if (v instanceof Data_Maybe.Nothing) {
        return "0:00";
    };
    if (v instanceof Data_Maybe.Just) {
        var seconds = convertDuration(v.value0);
        var displaySeconds = Data_Int.floor(Data_Number.remainder(coerce(seconds))(60.0));
        var displaySecondsString = (function () {
            var $38 = displaySeconds < 10;
            if ($38) {
                return "0" + show(displaySeconds);
            };
            return show(displaySeconds);
        })();
        var displayMinutes = Data_Int.floor(coerce(seconds) / 60.0);
        return i(show(displayMinutes))(":")(displaySecondsString);
    };
    throw new Error("Failed pattern match at Visonum.Cross.Util (line 49, column 1 - line 49, column 47): " + [ v.constructor.name ]);
};
var everyNth = function (n) {
    return function (items) {
        return filterMap(function (v) {
            var $41 = mod(v.value0)(n) === 0;
            if ($41) {
                return new Data_Maybe.Just(v.value1);
            };
            return Data_Maybe.Nothing.value;
        })(Data_Array.mapWithIndex(Data_Tuple.Tuple.create)(items));
    };
};
var bool = function (v) {
    return function (v1) {
        return function (v2) {
            if (v) {
                return v1;
            };
            if (!v) {
                return v2;
            };
            throw new Error("Failed pattern match at Visonum.Cross.Util (line 40, column 1 - line 40, column 41): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var appendWithSpace = function (s1) {
    return function (s2) {
        return s1 + (" " + s2);
    };
};
export {
    appendWithSpace,
    bool,
    everyNth,
    formatDigitalClock,
    getVisiblePingMax,
    getVisibleSpeedMax,
    overAlpha,
    withAttrs
};
